import React, {useState, useEffect} from 'react';
import {Container, Grid, Button, Divider,} from '@material-ui/core/';
import { useHistory } from "react-router-dom";

function FormularioCambiarContraseña(props) {
    let history = useHistory();

    const ObtenerCodigo = () =>{
        history.push("/cambiarContraseña/obtenerCodigo",{})
    }

    return (
        <div>
            <Container maxWidth="lg" >
                <Grid container >
                    <Grid container item xs={12} direction="row" justify="center" alignItems="center">
                        <span>Si has olvidado tu contraseña puedes recuperarla dando clic en el botón <strong>¿HAS OLVIDADO TU CONTRASEÑA? </strong></span>
                    </Grid>                    
                    <Grid container item xs={12} direction="row" justify="center" alignItems="center">
                        <Button onClick={ObtenerCodigo} variant="outlined">¿Has olvidado tu contraseña?</Button>
                    </Grid>                    
                </Grid>                    
            </Container>
            <br/>
        </div>
    );
}


export default FormularioCambiarContraseña;